<div class="offline">You are offline</div>
